"use client";

// import { LoadingButton } from "@/components/loading-button";
import { Button } from "@/components/ui/button";
import { useTranslations } from "@/hooks/useTranslations";
import { authClient } from "@/lib/auth-client";
import { POST_LOGOUT_PATH } from "@/lib/auth-navigation";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { clearSessionOnLogout } from "@/lib/clear-session-on-logout";
import { toast } from "sonner";

export function LogoutEverywhereButton() {
  const t = useTranslations("auth");
  const [loading, setLoading] = useState(false);

  const router = useRouter();

  async function handleLogoutEverywhere() {
    setLoading(true);
    const { error } = await authClient.revokeSessions();
    if (error) {
      toast.error(error.message || "Failed to log out everywhere");
      return;
    }
    await authClient.signOut({
      fetchOptions: {
        onSuccess: () => {
          router.push(POST_LOGOUT_PATH);
          router.refresh();
          clearSessionOnLogout();
          setTimeout(() => {
            window.location.href = POST_LOGOUT_PATH;
          }, 50);
        },
        onError: (err) => {
          console.error("Logout failed", err);
        },
      },
    });
    router.refresh()
    setLoading(false);
  }

  return (
    // <LoadingButton
    //   variant="destructive"
    //   onClick={handleLogoutEverywhere}
    //   loading={loading}
    //   className="w-full"
    // >
    //   LOG ME OUT
    // </LoadingButton>
    <Button
      variant="destructive"
      onClick={handleLogoutEverywhere}
      border
      theme="white"
      showArrow
      pressEffect={false}
      shadow={false}
      loading={loading}
      type="submit"
      className="w-full py-3 transition-colors"
    >
      {t?.signOut || "LOG ME OUT"}
    </Button>
  );
}
